/*global require*/
import React, { Component, PropTypes } from 'react';
import Transitions from 'material-ui/lib/styles/transitions';
import shallowEqual from 'shallowequal';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import { IconButton, Styles } from 'material-ui';
import { formatDate } from '../../helpers/formatDate';

const { Spacing } = Styles;

const iconSize = Spacing.iconSize * 2;
const fontSize = 16;

const styles = {
  root: {
    display: 'block',
    fontSize: fontSize,
    lineHeight: `${fontSize}px`,
    position: 'relative',
    transition: Transitions.easeOut(),
    padding: (iconSize - fontSize) / 2 + Spacing.desktopGutterMini / 2,
    borderStyle: 'solid none none none',
    borderWidth: 1,
    borderColor: Colors.Text.Dark.divider
  },
  label: {
    paddingLeft: iconSize + Spacing.desktopGutterMini,
    paddingRight: iconSize + Spacing.desktopGutterMini * 28
  },
  mouseOver: {
    backgroundColor: Colors.Colors.grey[300].material
  },
  navigateButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    borderStyle: 'none none none solid',
    borderWidth: 1,
    borderColor: Colors.Text.Dark.divider,
    padding: `${Spacing.desktopGutterMini / 2}px 0`,
    backgroundColor: Colors.Theme.Light.background
  },
  leftIcon: {
    position: 'absolute',
    left: Spacing.desktopGutterMini / 2,
    top: 0,
    bottom: 0,
    padding: `${Spacing.desktopGutterMini / 2}px 0`
  },
  icon: {
    width: iconSize,
    height: iconSize
  },
  date: {
    position: 'absolute',
    right: '100px',
    top: '20px',
    fontSize: '12px'
  },
  date2: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    fontSize: '12px'
  }
};

export default class ListItem extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    mosueOver: false
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }

  getStyle() {
    return Object.assign(
      {},
      styles.root,
      this.state.mouseOver ? styles.mouseOver : null
    );
  }

  getLabelStyle() {
    return Object.assign({}, styles.label);
  }

  handleMouseEnter() {
    this.setState({ mouseOver: true });
  }

  handleMouseLeave() {
    this.setState({ mouseOver: false });
  }

  handleTouchTap(item) {
    if (this.props.onTouchTap) {
      this.props.onTouchTap(item);
    }
  }

  handleLeftIconTouchTap(item, event) {
    event.stopPropagation();
    if (this.props.onLeftIconTouchTap) {
      this.props.onLeftIconTouchTap(item);
    }
  }

  handleNavigateTouchTap(item, event) {
    event.stopPropagation();
    if (this.props.onNavigateTouchTap) {
      this.props.onNavigateTouchTap(item);
    }
  }

  render() {
    const { item, children, ...other } = this.props;
    let icon, xIcon;
    let date = formatDate(item.created);

    if (this.props.leftIcon) {
      icon = React.cloneElement(this.props.leftIcon, {
        color: Colors.Text.Dark.secondary,
        hoverColor: Colors.Text.Dark.text,
        style: styles.icon
      });
    }

    if (this.props.payload === 'archive') {
      xIcon = null;
    } else {
      xIcon = (
        <div>
          <IconButton
            tooltip={this.context.getIntlMessage('item.read')}
            tooltipPosition="top-left"
          >
            <Icons.NavigationCheck
              color={Colors.Text.Dark.secondary}
              hoverColor={Colors.Text.Dark.text}
              style={styles.icon}
            />
          </IconButton>
        </div>
      );
    }

    return (
      <div
        style={this.getStyle()}
        onMouseEnter={::this.handleMouseEnter}
        onMouseLeave={::this.handleMouseLeave}
      >
        <div
          {...other}
          style={this.getLabelStyle()}
          onTouchTap={this.handleTouchTap.bind(this, item)}
        />
        {children}
        <div
          style={this.props.payload === 'archive' ? styles.date2 : styles.date}
        >
          {date}
        </div>
        <div
          style={styles.leftIcon}
          onTouchTap={this.handleLeftIconTouchTap.bind(this, item)}
        >
          {icon}
        </div>
        <div
          style={styles.navigateButton}
          onTouchTap={this.handleNavigateTouchTap.bind(this, item)}
        >
          {xIcon}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/ListItem.js